export default "__VITE_ASSET__BV6XAdnx__"